module.exports = __webpack_public_path__ + "5cfe3e988975ba8d96e302e5fdeb58c2.svg";